"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Caret = _interopRequireDefault(require("./Caret"));

var _excluded = ["disabled", "bsStyle", "className"];

var SplitCaretButton = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var disabled = _ref.disabled,
      bsStyle = _ref.bsStyle,
      className = _ref.className,
      remainingProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var splitCaretButtonClasses = (0, _classnames.default)('dropdown-toggle', 'btn', "btn-".concat(bsStyle), disabled && 'disabled', className);
  return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({}, remainingProps, {
    role: 'button',
    type: 'button',
    className: splitCaretButtonClasses,
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(_Caret.default, null));
});

var _default = SplitCaretButton;
exports.default = _default;
SplitCaretButton.propTypes = {
  disabled: _propTypes.default.bool,
  bsStyle: _propTypes.default.oneOf(['default', 'primary', 'info', 'warning', 'danger', 'success', 'link', 'muted']),
  className: _propTypes.default.string
};